/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGitPullRequest = createReactComponent("outline", "git-pull-request", "IconGitPullRequest", [["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6 8l0 8", "key": "svg-3" }], ["path", { "d": "M11 6h5a2 2 0 0 1 2 2v8", "key": "svg-4" }], ["path", { "d": "M14 9l-3 -3l3 -3", "key": "svg-5" }]]);

export { IconGitPullRequest as default };
//# sourceMappingURL=IconGitPullRequest.mjs.map
